import { Typography } from "@mui/material";
import { CDialog, CModal } from "../data-display";
import { Pacote } from "../../types";
import { usePacotes } from "../../services";
import DeleteIcon from "@mui/icons-material/Delete";
import { memo } from "react";

interface ModalDeletePacotesProps {
  data: Pacote;
}

export const ModalDeletePacotes = memo(({ data }: ModalDeletePacotesProps) => {
  const { deletePacote } = usePacotes();

  const handleDelete = async () => {
    await deletePacote(data);
  };

  return (
    <CDialog
      title="Deletando Item"
      onSave={handleDelete}
      iconButton={<DeleteIcon color="error" />}
      type="error"
    >
      <Typography variant="subtitle1">
        Você tem certeza que deseja deletar o item {data.title}?
      </Typography>
    </CDialog>
  );
});
